import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { AppConfig } from '../../app.config';
import { BaseService } from './baseService';
import { AppInsightService } from './app-insight.service';

@Injectable()
export class InterviewDetailsService extends BaseService{
    private controllerName:string = '/CaseInterview/'

    constructor(protected http: HttpClient, protected config: AppConfig, protected appInsights: AppInsightService) {
        super(http, config, appInsights);
    }

    public uploadInterviewFile(caseId:string, file: any): Promise<any> {
        var re = /(?:\.([^.]+))?$/;
        var ext = re.exec(file.name)[1];
        var fileName = file.name.replace(`.${ext}`, '');

        let formData: FormData = new FormData();
            formData.append('file', file, fileName);
        var url = `${this.controllerName}upload/`;
            url += (caseId);
        
        return this.httppost<any>(url, formData);
    }

    public downloadInterviewFile(caseId:string, fileName:string): Promise<any> {
        let url = `${this.controllerName}download/`;
            url += (caseId + '/');
            url += (fileName);
        return this.httpgetblob<any>(url);
    }

    public deleteInterviewFile(caseId:string, fileName:string): Promise<any> {
        let url = `${this.controllerName}delete/`
        url += (caseId + '/');
        url += (fileName);
        
        return this.httppost<any>(url, null);
    }
}

export class InterviewDetails
{
    public FamilyInterviewsConducted:string;
    public NumberInterviewsConducted:number;
    public InterviewDescription:string;

    public InterviewDocuments:InterviewDocument[];
}

export class InterviewDocument
{
    public FileName:string;
    public Extension:string;
    public FileSize:number;
    public UploadDate:any;
}
